// extracted by mini-css-extract-plugin
export var alternate = "_q-h";
export var black = "_q-3";
export var blue = "_q-d";
export var blueLight = "_q-c";
export var brand = "_q-7";
export var error = "_q-9";
export var gray = "_q-6";
export var grayBlue = "_q-b";
export var iconWrapper = "_q-4";
export var indigo = "_q-e";
export var orange = "_q-g";
export var pink = "_q-f";
export var primary = "_q-0";
export var purple = "_q-8";
export var success = "_q-5";
export var warning = "_q-a";
export var white = "_q-1";
export var whiteSuccess = "_q-2";